import { CREHANA_BASE_URL_PRD } from "@crehana/constants";
import { customLocalStorage, getUserDistinctId } from "@crehana/utils";
import { v4 } from "uuid";
const USER_ACTIVITY_ENDPOINT = '/api/v3/user-activity/';
const showLogs = (event, status, payload, message)=>{
    if (customLocalStorage.getItem('user_activity_logger_enabled')) {
        const startGroup = console.group.bind(console);
        const endGroup = console.groupEnd.bind(console);
        const info = console.info.bind(console);
        startGroup('------ UserActivity track ------');
        info('event:', event);
        if (payload) info('payload:', payload);
        info('status:', status);
        if (message) info('message:', message);
        endGroup();
    }
};
const trackUserActivity = ({ event, data, user, nextUrl, jwtToken })=>new Promise((resolve)=>{
        const isDesktop = "u" > typeof window && window.location.href.includes('file://');
        const localStorageUser = customLocalStorage.getItem('creh-tracking-data');
        const userData = user || (localStorageUser ? JSON.parse(localStorageUser) : void 0);
        const generalTrackData = {
            event_uuid: v4(),
            event_type: event,
            app_platform: data?.app_platform || 'web',
            api_version: 2,
            ...userData || {},
            distinct_id: getUserDistinctId().distinctId
        };
        const payload = [
            {
                ...generalTrackData,
                ...data
            }
        ];
        const envEndpoint = 'development' === process.env.NODE_ENV ? 'https://qa.creha.co' : CREHANA_BASE_URL_PRD;
        const completeEndpoint = data?.app_platform === 'desktop' || isDesktop ? `${envEndpoint}${USER_ACTIVITY_ENDPOINT}` : USER_ACTIVITY_ENDPOINT;
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (data?.app_platform === 'desktop' || isDesktop) {
            headers.append('REQUEST_CURRENT_PLATFORM', 'desktop');
            headers.append('Authorization', `JWT ${jwtToken}`);
        }
        try {
            fetch(completeEndpoint, {
                method: 'POST',
                headers,
                credentials: 'include',
                body: JSON.stringify(payload)
            }).then((res)=>res.json()).then((res)=>{
                const status = res?.success ? 'success' : 'error';
                const message = res?.length ? res[0]?.message : res?.message;
                showLogs(event, status, payload, message);
                if (nextUrl) window.location.href = nextUrl;
                else resolve({
                    status,
                    message
                });
            }).catch((err)=>{
                showLogs(event, 'error', payload, err);
                if (nextUrl) window.location.href = nextUrl;
                else resolve({
                    status: 'error',
                    message: err
                });
            });
        } catch (error) {
            showLogs(event, 'error', payload, String(error));
        }
    });
const UserActivity_trackUserActivity = trackUserActivity;
export default UserActivity_trackUserActivity;
export { USER_ACTIVITY_ENDPOINT };
